import { Link } from 'react-router-dom';
import clsx from 'clsx';
import { ROLE_INFO, SCORE_LABELS, type GameParticipantDto, type ScoreReason } from '@mafia/core';

const DEATH = { NIGHT_KILL: 'убит ночью', VOTE: 'исключён', LEFT: 'вышел' } as const;

export function ParticipantsTable({ participants, adminLinks }: { participants: GameParticipantDto[]; adminLinks?: boolean }) {
  return (
    <div className="overflow-x-auto">
      <table className="table-base">
        <thead>
          <tr>
            <th>№</th>
            <th>Игрок</th>
            <th>Роль</th>
            <th>Судьба</th>
            <th className="text-right">Баллы</th>
            <th className="text-right">Итог</th>
          </tr>
        </thead>
        <tbody>
          {participants.map((p) => (
            <tr key={p.seat}>
              <td className="font-mono text-zinc-500">{p.seat}</td>
              <td>
                {p.userId ? (
                  <Link to={adminLinks ? `/admin/users/${p.userId}` : `/profile/${p.userId}`} className="hover:text-gold-300">
                    {p.nickname}
                  </Link>
                ) : (
                  <span className="italic text-zinc-500">{p.nickname}</span>
                )}
              </td>
              <td className={p.team === 'MAFIA' ? 'text-blood-400' : p.team === 'MANIAC' ? 'text-purple-300' : ''}>
                {ROLE_INFO[p.role].emoji} {ROLE_INFO[p.role].name}
              </td>
              <td className="text-zinc-400">
                {p.survived === null ? '—' : p.survived ? 'выжил' : `${p.deathReason ? DEATH[p.deathReason] : 'выбыл'}${p.deathDay ? ` (день ${p.deathDay})` : ''}`}
              </td>
              <td
                className="text-right font-semibold tabular-nums text-gold-300"
                title={p.pointsBreakdown
                  .map((e) => `${SCORE_LABELS[e.reason as ScoreReason] ?? e.reason}: ${e.points > 0 ? '+' : ''}${e.points}`)
                  .join('\n')}
              >
                {p.points}
              </td>
              <td className={clsx('text-right font-medium', p.isWinner ? 'text-emerald-300' : 'text-zinc-500')}>
                {p.isWinner === null ? '—' : p.isWinner ? 'победа' : 'поражение'}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
